import { apiClient } from './client';

export interface Channel {
    id: string; // pluginId
    name: string;
    description?: string;
    icon?: string;
    category?: string;
    isActive: boolean;
    [key: string]: any;
}

export const adminChannelsApi = {
    getAll: async () => {
        const response = await apiClient.get<{ success: boolean, data: Channel[] }>('/admin/channels');
        return response.data.data;
    },

    updateStatus: async (id: string, isActive: boolean) => {
        const response = await apiClient.put<{ success: boolean, data: any }>(`/admin/channels/${id}/status`, { isActive });
        return response.data;
    }
};
